<div class="container">
    <h1 class="mt120">Donate</h1>
    <hr class="mb-0" />
</div>

<div class="mainContnet">
    <div class="container">
        <p>To donate to the work of the Institute for Training in Ministry (iTIM)., click the button below. Thank you.</p>
                <div id="donate-button-container">
                    <div id="donate-button"></div>
                   
                </div>
    </div>
   
    <app-static-footer></app-static-footer>
</div>